"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@prismicio/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Image = function Image(_ref) {
  var element = _ref.element,
      currentClass = _ref.currentClass;

  if (element) {
    return /*#__PURE__*/_react["default"].createElement(_react2.PrismicImage, {
      field: element,
      className: currentClass
    });
  }

  return null;
};

Image.propTypes = {
  element: _propTypes["default"].shape({}).isRequired,
  currentClass: _propTypes["default"].string.isRequired
};
var _default = Image;
exports["default"] = _default;